module.exports = __webpack_public_path__ + "static/media/my_clients.1eae5fcb.png";